import React, { FC } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { MockTraceabilityLegend } from './mocks/MockLegend';
import { isPresent } from '@farmai-shared/LFUtils';
import { SankeyResponse } from '@services/responseTypes';
import clsx from 'clsx';
export const TraceabilityLegend: FC<{
  data?: SankeyResponse['nodes'];
  legendColors: {
    [k: string]: string;
  };
}> = observer(({
  data = [],
  legendColors
}) => {
  const {
    t
  } = useTranslation();
  if (!isPresent(data)) {
    return <MockTraceabilityLegend title={t('noTraceabilityLegendData')} />;
  }
  return <div className="flex flex-col gap-8">
      {data.map(({
      name,
      place
    }) => <div key={`traceability.legend.${place?.id || name}`}>
          <div className="flex gap-x-4">
            <div className={clsx('mt-2 h-4 min-w-4 rounded-full', 'print:ml-8 print:!bg-[var(--legend-color)]')} style={{
          '--legend-color': legendColors[name],
          backgroundColor: legendColors[name]
        } as React.CSSProperties} />
            <div className="font-light">
              <p>{t(name, {
              defaultValue: name
            })}</p>
              {place && <p className="text-grey">{place.address}</p>}
            </div>
          </div>
        </div>)}
    </div>;
});